import pathOr from 'lodash/fp/pathOr';
import assoc from 'lodash/fp/assoc';
import pipe from 'lodash/fp/pipe';

const getBarbers = pathOr([], 'barbers');
const countBarbers = shop => assoc('barberCount', getBarbers(shop).length, shop);

const countShopBarbers = pipe(countBarbers);

export default countShopBarbers;
